export const scorecardRowLabel = (row) => {
  const parts = [row?.full_name || ''];
  if (row?.employee_number) parts.push(`(${row.employee_number})`);

  let label = parts.join(' ').trim();
  if (row?.balanced_scorecard_setting_name) label += ` · ${row.balanced_scorecard_setting_name}`;

  return label;
};

export const scorecardWeighting = (row) => (
  row?.scorecard_count > 1 && row?.distribution_percentage ? row.distribution_percentage : null
);

// Per-employee mode: true when a ticked row has no value yet.
export const hasEmptyInstanceRow = (selected, actionMode, instanceValues) => (
  actionMode !== 'overwrite' && (selected || []).some(hashId => !instanceValues?.[hashId])
);

export const buildScorecardUpdates = (selected, actionMode, value, instanceValues) => (
  (selected || [])
    .map(hashId => ({ hash_id: hashId, value: actionMode === 'overwrite' ? value : (instanceValues?.[hashId] || '') }))
    .filter(entry => entry.value !== '' && entry.value != null)
);
